import React from 'react';
import _ from 'underscore';
import Popup from 'views/shared/ui/popup';
import { roundPrice } from 'lib/pricing_utils';
import { t } from 'services/translation';
import './index.scss';

class CheckoutSummaryPricingBreakdown extends React.Component {
  static displayName = 'CheckoutSummaryPricingBreakdown';

  static defaultProps = {
    booking_fee_popup_content: t(
      'INCLUDES_CREDIT_CARD_PROCESSING_AND_SERVICE_PROVIDER_FEES'
    ),
    units: {
      items: [],
    },
  };

  _renderAddonPricing = (addon, index) => {
    if (parseFloat(addon.total) === 0) {
      return null;
    }

    return (
      <div
        className="two column row"
        data-testid="addon-checkout-summary"
        key={index}
      >
        <div className="left aligned column PriceBreakDown-label">
          <div className="addonName">{addon.name}</div>
          <div className="addonBreakdown">
            <span className="addonPrice" data-testid="addon-price">
              {roundPrice(addon.unit_price_formatted)}
            </span>
            <span className="addonGuests" data-testid="addon-guests">
              {addon.per_person
                ? ` x ${addon.guests}`
                : ` ${t('FOR_ALT')} ${addon.guests}`}
            </span>
          </div>
        </div>
        <div className="column PriceBreakDown-value" data-testid="addon-fee">
          {addon.total_formatted}
        </div>
      </div>
    );
  };

  _renderAddons = () => {
    const self = this;

    return _.map(this.props.addons.items, (addon, index) => {
      return self._renderAddonPricing(addon, index);
    });
  };

  _renderBookingFee = () => {
    if (this.props.includes_booking_fee) {
      return (
        <div className="two column row">
          <div className="left aligned column">
            <div className="BookingFee-Container">
              <span role="button" tabIndex="0" className="dotted">
                {t('SERVICE_FEE')}
              </span>
              <span
                role="button"
                tabIndex="0"
                aria-label="service fee tooltip"
                aria-describedby="service-fee-desc"
                className="icon af-help-circle BookingFee-popup-target"
              />
              {this._renderBookingFeePopup()}
            </div>
          </div>
          <div
            className="column PriceBreakDown-value"
            data-testid="service-fee"
          >
            {this.props.booking_fee_formatted}
          </div>
        </div>
      );
    }
    return null;
  };

  _renderPricingUnits = () => {
    if (this.props.units.items === undefined) {
      return null;
    }
    return this.props.units.items
      .filter((unit) => {
        return unit.count > 0;
      })
      .map((unit) => {
        return (
          <div className="unit">
            {roundPrice(unit.unit_price_formatted)}&nbsp;
            {unit.per_tour === true ? t('FOR') : 'x'}&nbsp;
            {unit.count}&nbsp;
            {unit.count === 1 ? t(unit.noun_singular) : t(unit.noun_plural)}
            &nbsp;
          </div>
        );
      });
  };

  _renderPriceSummary = () => {
    return (
      <div className="two column row PriceBreakdown-summary">
        {this._renderPricingUnits()}
      </div>
    );
  };

  _renderSubtotal = () => {
    return [
      <div className="left aligned column">{t('SUBTOTAL')}</div>,
      <div className="column PriceBreakDown-value" data-testid="actual-value">
        {roundPrice(this.props.guests_price_formatted)}
      </div>,
    ];
  };

  _renderAdditionalTax = () => {
    if (this.props.includes_additional_tax) {
      return (
        <div className="two column row">
          <div className="left aligned column">
            {this.props.additional_tax_label}
          </div>
          <div className="column PriceBreakDown-value">
            {roundPrice(this.props.additional_tax_formatted)}
          </div>
        </div>
      );
    }
    return null;
  };

  _renderDiscount = () => {
    if (this.props.includes_discount) {
      return (
        <div className="two column row">
          <div className="left aligned column">
            {t('PROMO_CODE')}: <br />
            {this.props.discount_code}
          </div>
          <div
            className="column PriceBreakDown-value"
            data-testid="promo-value"
          >
            {roundPrice(this.props.discount_formatted)}
            <span className="toggleIconContainer">
              (<span className="icon af-minus-ar" />)
            </span>
          </div>
        </div>
      );
    }
    return null;
  };

  _renderOnlineDiscount = () => {
    if (this.props.includes_online_discount) {
      return (
        <div className="two column row">
          <div className="left aligned column">Online Payment Discount</div>
          <div className="column PriceBreakDown-value">
            {roundPrice(this.props.online_discount_formatted)}
            <span className="toggleIconContainer">
              (<span className="icon af-minus-ar" />)
            </span>
          </div>
        </div>
      );
    }
    return null;
  };

  serviceFeePopupContent = () => (
    <div id="service-fee-desc">{this.props.booking_fee_popup_content}</div>
  );

  _renderBookingFeePopup = () => {
    return (
      <Popup
        content={this.serviceFeePopupContent()}
        target=".BookingFee-popup-target"
        identifier="popup-PriceBreakDown"
        position="bottom right"
        on="focus"
      />
    );
  };

  render() {
    return (
      <div className="PriceBreakDown">
        <div className="ui grid">
          <div className="two column row">
            {this._renderSubtotal()}
            {this._renderPriceSummary()}
          </div>
          {this._renderAddons()}
          {this._renderDiscount()}
          {this._renderAdditionalTax()}
          {this._renderOnlineDiscount()}
          {this._renderBookingFee()}
        </div>
      </div>
    );
  }
}

export default CheckoutSummaryPricingBreakdown;
